import React from 'react';
var FiveHundred = function FiveHundred() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "ERROR 500"), /*#__PURE__*/React.createElement("h1", null, "We're Sorry, Something Went Wrong"), /*#__PURE__*/React.createElement("p", null, "If you are the application owner check the logs for more information."));
};
export default FiveHundred;